import { Paragraph, Spacing, Title } from "@sicredi/react";
import { Line } from "../../Line";
import styles from "./styles.module.scss";

export function HeaderCardPlanSmall() {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <Title as="h4" weight="semi-bold">
          Ofertas relacionadas
        </Title>
        <Spacing appearance="xx-small" />
        <Line />
      </div>

      <div className={styles.paragraph_container}>
        <Paragraph className={styles.paragraph} weight="normal">
          Valor
        </Paragraph>
        <Paragraph className={styles.paragraph} weight="normal">
          Parcela
        </Paragraph>
        <Paragraph className={styles.paragraph} weight="normal">
          Prazo
        </Paragraph>
        <Paragraph className={styles.paragraph} weight="normal">
          Taxa de Administração
        </Paragraph>
      </div>
    </div>
  );
}
